import { Component, OnInit } from "@angular/core";
import { LoginService } from "src/app/services/login.service";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { SharedService } from "src/app/services/shared.service";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { LoginResponse } from "src/app/models/Masters/userMaster";
import { ScanFilterStateService } from "src/app/services/scan-filter-state.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  form1: FormGroup;
  form1Submitted: boolean;
  formRestPassword: FormGroup;
  resetFormSubmitted: boolean;
  isModalShown: boolean;
  forgotPasswordMessage: string;
  iscaptcha: boolean;
  isLoggingIn = false;
  constructor(
    private loginService: LoginService,
    private router: Router,
    private messageService: MessageService,
    private sharedService: SharedService,
    private fb: FormBuilder,
    private scanFilterState: ScanFilterStateService,
  ) {
    this.initForm();
    this.initResetPasswordForm();

    if (
      window.location.href.indexOf("localhost") > -1 ||
      window.location.href.indexOf("sureassure.com") > -1 
     
    ) {
      this.iscaptcha = false;
    } else {
      this.iscaptcha = true;
    }
  }

  ngOnInit() {}

  initResetPasswordForm() {
    this.formRestPassword = this.fb.group({
      usrNm: [null, Validators.required],
    });
  }
  public checkUser(login) {
    this.isLoggingIn = true;
    this.loginService.checkUser(login).subscribe(
      (userDetails: LoginResponse) => {
        if (userDetails.responseCode === "200") {
          localStorage.clear();
          sessionStorage.clear();
          this.scanFilterState.reset();
          if (userDetails.data.companyDetails.length > 0) {
            var companyDetails = userDetails.data.companyDetails.filter(
              (company) => company.compId == userDetails.data.compId,
            );
            userDetails.data.compId = companyDetails[0].compId;
            userDetails.data.roleId = companyDetails[0].roleId;
            userDetails.data.compNm = companyDetails[0].compNm;
            userDetails.data.isLoyalty = companyDetails[0].IsLoyalty;
          }
          localStorage.user = JSON.stringify(userDetails.data);
          localStorage.token = userDetails.data.token;
          localStorage.refreshToken = userDetails.data.refreshToken;
          const isLoyalty: any = userDetails.data.isLoyalty;
          const isLoyaltyEnabled =
            isLoyalty === true ||
            isLoyalty === "true" ||
            isLoyalty === "1" ||
            isLoyalty === 1;
          this.router.navigateByUrl(
            isLoyaltyEnabled ? "/dashboard" : "/dashboard1",
          );
          // if (userDetails.isPasswordReset) {
          //   this.router.navigateByUrl('/changepassword');
          // } else {
          //   this.router.navigateByUrl('/home');
          // }
        } else {
          this.isLoggingIn = false;
          /// Resolved defect CC-D- 01
          this.messageService.add({
            severity: "warn",
            summary: "Warning",
            detail: userDetails.responseMessage,
          });
        }
      },
      (err) => {
        this.isLoggingIn = false;
      },
    );
  }
  initForm() {
    this.form1 = this.fb.group({
      usrNm: [null, Validators.required],
      usrPswd: [null, Validators.required],
      loggedInUsing: [1],
      loginType: ["SureAssure"],
      myCaptcha: [null],
    });
  }
  get f() {
    return this.form1.controls;
  }
  get freset() {
    return this.formRestPassword.controls;
  }
  onSubmit() {
    this.form1Submitted = true;
    if (this.form1.invalid) {
      return;
    }

    if (
      this.form1.value.myCaptcha != undefined ||
      this.form1.value.myCaptcha == null
    ) {
      if (
        this.form1.value.myCaptcha == null &&
        this.form1.value.usrNm &&
        this.form1.value.usrPswd &&
        (window.location.href.indexOf("localhost") > -1 ||
          window.location.href.indexOf("sureassure.com") > -1)
      ) {
        this.messageService.add({
          severity: "warn",
          summary: "Warning",
          detail: "Please select captcha",
        });
        return;
      }
    }
    (<any>window).grecaptcha.reset();
    this.form1.patchValue({
      myCaptcha: null,
    });
    this.checkUser(this.form1.value);
  }
  onResetPasswordSubmit() {
    this.resetFormSubmitted = true;
    if (this.formRestPassword.invalid) {
      return;
    }
    const form = { ...this.formRestPassword.value };
    this.forgotPassword(form.usrNm);
  }
  forgotPassword(usrNm: any) {
    this.loginService.forgotPassword(usrNm).subscribe((resp: any) => {
      this.forgotPasswordMessage = resp.responseMessage;
    });
  }
  handleForgotPassword() {
    this.isModalShown = true;
  }
  closeResetPassModal() {
    this.resetForgotPassword();
    this.isModalShown = false;
  }
  resetForgotPassword() {
    this.resetFormSubmitted = false;
    this.initResetPasswordForm();
    const obj = this.freset;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key].setErrors(null);
      }
    }
  }

  showResponse(event: any) {
    if (event.response) {
      this.form1.patchValue({
        myCaptcha: event.response,
      });
    }
  }
}
